module.exports = __webpack_public_path__ + "static/poloclub-MONEI-a721d5f433f8b58e0e6731bced7815f8.png";